<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Users
        <small>List of users</small>
      </h1>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-sm-6">
          <button @click="group = 0" class="btn btn-default">All</button>
          <button @click="group = 1" class="btn btn-primary">Facebook</button>
          <button @click="group = 2" class="btn btn-info">E-mail</button>
        </div>
        <div class="col-sm-6">
          <form class="form-horizontal">
            <div class="form-group">
              <label for="type" class="col-sm-2 control-label">Pretraga po:</label>
              <div class="col-sm-10">
                <select v-model="type" id="type" class="form-control">
                  <option value="nickname" selected>Nickname</option>
                  <option value="email">Email</option>
                  <option value="id">ID</option>
                  <option value="firstname">First Name</option>
                  <option value="lastname">Last Name</option>
                  <option value="color">Color</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label for="term" class="col-sm-2 control-label">Traži</label>
              <div class="col-sm-10">
                <input autocomplete="off" v-model="term" @keyup="searchUser()" type="text" id="term" placeholder="Traži" class="form-control">
              </div>
            </div>
          </form>
          <!--<div class="form-inline">-->
            <!--<input v-model="search" type="text" class="form-control" placeholder="Nickname..." />-->
            <!--<input v-model="searchName" type="text" class="form-control" placeholder="FB / E-mail" />-->
          <!--</div>-->
        </div>
      </div>
      <table class="table table-hover">
        <thead>
        <tr>
          <th>#</th>
          <th>Nick</th>
          <th>Name | E-mail</th>
          <th>Age range</th>
          <!--<th>Role</th>-->
          <th v-if="role >= 40">Pwd</th>
          <!--<th>FB NALOG</th>-->
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <!--<tr v-for="user in visiblePaginated">-->
        <tr v-for="user in users">
          <th scope=row>{{ user.id }}</th>
          <td>
            <form class="form-inline" @submit.prevent="changeNick($event)">
              <input type="hidden" class="user-id" name="user_id" :value="user.id" />
              <input type="text" class="form-control user-nickname" :value="testUri(user.nickname)" />
              <button class="btn btn-primary" type="submit">Sačuvaj</button>
            </form>
          </td>
          <td v-if="user.facebook_id != null">
            <a :href="'https://facebook.com/' +  user.facebook_id">fb: {{ user.firstname }} {{ user.lastname }}</a>
          </td>
          <td v-else>
            {{ user.email }}
          </td>
          <td>{{ user.age_range }}</td>
          <!--<td>{{ user.role }}</td>-->
          <td v-if="role >= 40">{{ user.password_view }}</td>
          <!--<td>-->
            <!--<select v-model="fb_selected" @changed="changeFB()">-->
              <!--<option v-for="fb in fb_users" :value="fb.id">{{fb.id}}. {{fb.firstname}} {{fb.lastname}}</option>-->
            <!--</select>-->
          <!--</td>-->
          <td>
            <button @click="aboutUser(user)" class="btn btn-info">Info</button>
            <button @click="deleteUser(user.id)" class="btn btn-danger">Delete</button>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="pagination-wrap">
        <ul class="pagination">
          <li v-for="cnt in numberOfPages">
            <a @click="changePage(cnt)" :class="[cnt == currentPage ? 'active':'']" href="#">{{ cnt }}</a>
          </li>
        </ul>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="myModal" role="dialog">
        <div class="modal-dialog">

          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">Informacije o igraču:</h4>
            </div>
            <div class="modal-body">
              <form class="form-horizontal">

                <div v-if="userInfo.id != 0">

                  <div class="form-group">
                    <label class="control-label col-sm-3" for="user_id">ID:</label>
                    <div class="col-sm-9">
                      <input type="text" :value="userInfo.id" class="form-control" id="user_id" disabled>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label col-sm-3" for="nickname">Nickname:</label>
                    <div class="col-sm-9">
                      <input type="text"  :value="testUri(userInfo.nickname)" class="form-control" id="nickname">
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label col-sm-3" for="email">Email:</label>
                    <div class="col-sm-9">
                      <input type="text"  :value="userInfo.email" class="form-control" id="email" placeholder="Enter email">
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label col-sm-3" for="password_view">Password:</label>
                    <div class="col-sm-9">
                      <input type="text"  :value="userInfo.password_view" class="form-control" id="password_view">
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label col-sm-3" for="coins">Coins:</label>
                    <div class="col-sm-9">
                      <input type="number"  :value="userInfo.coins" class="form-control" id="coins">
                    </div>
                  </div>

                  <div class="form-group" v-if="userInfo.facebook_id != null">
                    <label class="control-label col-sm-3" for="nickname">Facebook:</label>
                    <div class="col-sm-9">
                      <div>
                        <a :href="'https://facebook.com/' +  userInfo.facebook_id">{{ userInfo.firstname }} {{ userInfo.lastname }}</a>
                      </div>
                      <div>
                        <p>Age Range: {{ userInfo.age_range }}</p>
                      </div>

                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label col-sm-3" for="skins-cards">Private skins:</label>
                  </div>
                  <div class="ui six stackable cards" id="skins-cards"  v-if="userInfo.skins.length">
                    <div class="col-sm-6 col-md-4 col-lg-3 card" :data-skin-id="item.id" v-for="item in userInfo.skins">
                      <img class="card-img-top" :src="'https://agar.rs/public/images/skins/'+item.skin_name+'.png'">
                      <div class="card-block">

                        <div class="card-text">
                          {{  item.ip }}
                        </div>
                      </div>
                      <div class="card-footer">
                        <!--<h4 class="text-center card-title mt-3">{{ item.user_id }}</h4>-->
                        <!--<h4 class="text-center card-title mt-3" >{{ decodeURI(item.nickname) }}</h4>-->
                        <!--&lt;!&ndash;<a style="font-size:14px;" :href="'https://fb.com/' + item.facebook_id"> | {{ item.firstname}} {{ item.lastname}}</a>&ndash;&gt;-->
                        <!--&lt;!&ndash;</h4>&ndash;&gt;-->


                        <button @click="removePrivateSkinDB(item.id, item.skin_name)" class="btn btn-danger float-right btn-sm">Delete</button>

                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </form>


            </div>

          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'Users',

    data: function () {
      return {
        form: new Form({}),
        users: [],
        number_of_users: 0,
        first_users: [],
        paginated: [],
        userInfo: {
          id: 0,
          skins: []
        },
        users_per_page: 100,
        role: 0,
        group: 0,
        search: '',
        searchName: '',
        currentPage: 1,
        term: '',
        type: 'nickname'
      }
    },
    computed: {
      numberOfPages: function () {
        var q = this.number_of_users / this.users_per_page
        if (this.number_of_users % this.users_per_page === 0) {
          return ~~q
        }
        return ~~q + 1
      },
      visiblePaginated: function () {
        var array = []
        var i = this.currentPage > 1 ? this.currentPage * this.users_per_page - this.users_per_page : 0
        for (i; i < this.currentPage * this.users_per_page; i++) {
          if (this.visible[i] !== undefined) {
            array.push(this.visible[i])
          }
        }
        return array
      },
      visible: function (value) {
        var self = this
        if (this.search !== '') {
          return this.users.filter(function (user) {
            return user.nickname !== null && user.nickname.indexOf(encodeURI(self.search)) !== -1
          })
        }
        if (this.searchName !== '') {
          return this.users.filter(function (user) {
            var fullname = (user.firstname + ' ' + user.lastname + ' ' + user.email).toLowerCase()
            return fullname.indexOf(self.searchName.toLowerCase()) !== -1
          })
        }
        if (this.group === 0) {
          return this.users
        } else if (this.group === 1) {
          return this.users.filter(function (user) {
            return user.facebook_id != null
          })
        } else {
          return this.users.filter(function (user) {
            return user.facebook_id == null
          })
        }
      }
    },
    methods: {
      fetchUsers: function (position) {
        var data = {
          'position': position,
          'user_id': localStorage.user_id,
          'token_header': localStorage.token_header,
          'token_log': localStorage.token_log
        }
        this.form.post(baseUrl + 'Admin/getAllUsers', data).then((result) => {
          if (result.status === 1) {
            this.users = result.list
            this.first_users = this.users
          }
        }, (reason) => {
        })
      },
      changePage: function (page) {
        this.currentPage = page
        if (this.users.length) {
          let lastUserId = this.users[this.users.length - 1].id
          this.users = []
          this.fetchUsers(lastUserId)
        }
      },
      changeGroup: function (id) {
        this.group = id
      },
      testUri: function (arg) {
        var valu = ''
        try {
          valu = decodeURI(arg)
        } catch (err) {
          valu = arg
          console.log('greska')
        }
        return valu
      },
      deleteUser (id) {
        var self = this
        var data = {
//          'user_id': localStorage.user_id,
          'token_header': localStorage.token_header,
          'token_log': localStorage.token_log,
          'id': id
        }
        this.form.post(baseUrl + 'Admin/deleteUsserss', data).then(function (result) {
          if (result.status === 1) {
            self.users.find((o, i) => {
              if (Number(o.id) === Number(id)) {
                if (i >= 0) {
                  self.users.splice(i, 1)
                  return 0
                }
              }
            })
          }
        }, function (reason) {
            // rejection
        })
      },
      aboutUser: function (user) {
        var self = this
        this.userInfo['id'] = user.id
        this.userInfo['nickname'] = user.nickname
        this.userInfo['email'] = user.email
        this.userInfo['firstname'] = user.firstname
        this.userInfo['lastname'] = user.lastname
        this.userInfo['facebook_id'] = user.facebook_id
        this.userInfo['age_range'] = user.age_range
        this.userInfo['password_view'] = user.password_view
        this.userInfo['color'] = user.color
        this.userInfo['coins'] = user.coins
        $('#myModal').modal('show')
        this.form.post(baseUrl + 'Admin/getUserPrivateSkins/' + user.id).then(function (result) {
          if (result.status === 1) {
            self.userInfo.skins = result.list
          }
        }, function (reason) {
        })
      },
      changeNick (e) {
        var nickname = $(e.target).find('.user-nickname').val()
        var id = $(e.target).find('.user-id').val()
        let data = {
          'name': encodeURI(nickname),
          'id': id,
          'token_header': localStorage.getItem('token_header'),
          'token_log': localStorage.getItem('token_log')
        }
        this.form.post(baseUrl + 'Admin/renameUser', data).then(function (result) {
          alert(result.msg)
        }, function (reason) {
            // rejection
        })
      },
      searchUser: function () {
        var self = this
        // // this.userList = []
        var searchTerm = this.term
        if (this.type === 'nickname') {
          searchTerm = encodeURI(this.term)
        }
        let data = {
          'term': searchTerm,
          'by': this.type,
          'user_id': localStorage.user_id,
          'token_header': localStorage.token_header,
          'token_log': localStorage.token_log
        }
        if (this.term.length > 2 || this.type === 'id' || this.type === 'color') {
          if (this.type === 'color') {
            data.term = searchTerm === '' ? null : searchTerm
          }
          self.users = []
          this.form.post(baseUrl + 'Admin/searchUser', data).then(function (result) {
            if (result.status === 1) {
              self.users = result.list
            }
          }, function (reason) {
          })
        }
      },
      removePrivateSkinDB: function (id, name) {
        var self = this
        var data = {
          'user_id': localStorage.user_id,
          'token_header': localStorage.token_header,
          'token_log': localStorage.token_log,
          'name': name,
          'id': id
        }
        this.form.post(baseUrl + 'Skins/removePrivateSkin', data).then(function (result) {
          if (result.status === 1) {
            self.userInfo.skins.find((o, i) => {
              if (o.skin_name === data.name) {
                if (i >= 0) {
                  self.userInfo.skins.splice(i, 1)
                  return 0
                }
              }
            })
          }
          if (result.status === 2) {
            localStorage.setItem('role', result.role)
          }
          // error
          if (result.status !== 1) {
            alert('Greska. Skin je vec obrisan')
          }
        }, function (reason) {
          // rejection
        })
      }
    },
    mounted: function () {
      this.role = Number(this.$store.state.role)
      if (Number(this.$store.state.role) < 33) {
        this.$router.push('/dashboard')
      }
      this.form.post(baseUrl + 'Admin/agarStructure').then((result) => {
        this.number_of_users = result.info.number_of_users
        this.fetchUsers(null)
      }, (reason) => {})
    }
  }
</script>
<style>
  .pagination-wrap {
    margin: 0 auto;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// Index.vue?c8d0f848